// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.userAnalyticsBox {
    width: 200px !important;
}

.userDateTime {
    font-size: 11px;
    line-height: 25px
}

.totalResult {
    font-size: 18px;
    line-height: 25px;
    font-weight: 500;
}

.countUsers {
    font-size: 23px;
    line-height: 40px;
    font-weight: 500;
}
.roleSelectCustom {
    padding: 1px 12px;
    font-size: 13px;
    font-weight: 500;
    height: 42px;
    appearance: none;
    width: 250px;
    min-width: 250px;
    max-width: 100%;
}

.filterTypeCustom {
    padding: 12px 17px;
    font-size: 13px;
    font-weight: 500;
    height: 42px;
    width: 130px;
    appearance: none;
}
.filterTypeCustom.calender{
    width: 150px;
}

.modal-table-container {
    max-height: 400px;
    overflow-y: auto;
    scrollbar-width: thin;
}

.modal-table-container thead {
    position: sticky;
    top: 0;
    z-index: 10;
    background-color: #1a1a1a; /* fallback dark background */
}

/* Ensure header cells have background for full coverage */
.modal-table-container thead th {
    background-color: inherit;
    border-bottom: 2px solid #333;
}
`, "",{"version":3,"sources":["webpack://./src/Pages/Site/Analytics/UsersAnalytics.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;AACpB;AACA;IACI,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,YAAY;IACZ,gBAAgB;AACpB;AACA;IACI,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,MAAM;IACN,WAAW;IACX,yBAAyB,EAAE,6BAA6B;AAC5D;;AAEA,0DAA0D;AAC1D;IACI,yBAAyB;IACzB,6BAA6B;AACjC","sourcesContent":[".userAnalyticsBox {\r\n    width: 200px !important;\r\n}\r\n\r\n.userDateTime {\r\n    font-size: 11px;\r\n    line-height: 25px\r\n}\r\n\r\n.totalResult {\r\n    font-size: 18px;\r\n    line-height: 25px;\r\n    font-weight: 500;\r\n}\r\n\r\n.countUsers {\r\n    font-size: 23px;\r\n    line-height: 40px;\r\n    font-weight: 500;\r\n}\r\n.roleSelectCustom {\r\n    padding: 1px 12px;\r\n    font-size: 13px;\r\n    font-weight: 500;\r\n    height: 42px;\r\n    appearance: none;\r\n    width: 250px;\r\n    min-width: 250px;\r\n    max-width: 100%;\r\n}\r\n\r\n.filterTypeCustom {\r\n    padding: 12px 17px;\r\n    font-size: 13px;\r\n    font-weight: 500;\r\n    height: 42px;\r\n    width: 130px;\r\n    appearance: none;\r\n}\r\n.filterTypeCustom.calender{\r\n    width: 150px;\r\n}\r\n\r\n.modal-table-container {\r\n    max-height: 400px;\r\n    overflow-y: auto;\r\n    scrollbar-width: thin;\r\n}\r\n\r\n.modal-table-container thead {\r\n    position: sticky;\r\n    top: 0;\r\n    z-index: 10;\r\n    background-color: #1a1a1a; /* fallback dark background */\r\n}\r\n\r\n/* Ensure header cells have background for full coverage */\r\n.modal-table-container thead th {\r\n    background-color: inherit;\r\n    border-bottom: 2px solid #333;\r\n}\r\n\r"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
